<template>
  <div class="finalizado">
    <h1>Anexos enviados com sucesso</h1>
    <p>Entraremos em contato em breve.</p>
  </div>
</template>

<script>
export default {
  name: 'contratoAssinado'
}
</script>
